import { render, staticRenderFns } from "./ShippingDashboard.vue?vue&type=template&id=54680cb1&scoped=true"
import script from "./ShippingDashboard.vue?vue&type=script&lang=js"
export * from "./ShippingDashboard.vue?vue&type=script&lang=js"
import style0 from "./ShippingDashboard.vue?vue&type=style&index=0&id=54680cb1&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "54680cb1",
  null
  
)

export default component.exports